export const apiConfig = {
  screen:
    (window.KONG_API_DOMAIN || '') +
    '/h/ca-web/apigw/screens/deeplink/{deeplink}',
};
